module.exports = __webpack_public_path__ + "static/media/night-cloudy-icon.4690ac34.svg";